import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";
import logo from "../../Image/dreamstars_logo.png";
import profile from "../../Image/profile.svg";
import camIcon from "../../favicon/sidebarIcons/campaigns.png";
import camRequest from "../../favicon/sidebarIcons/camRequest.png";
import myPosts from "../../favicon/sidebarIcons/myPosts.png";
import payouts from "../../favicon/sidebarIcons/payouts.png";
import report from "../../favicon/sidebarIcons/report.png";
import logout from "../../favicon/sidebarIcons/logout.png";
import list from "../../favicon/sidebarIcons/list.png";
import currencyFormatter from "../../Helpers/currencyFormatter";
import wallet from "../../favicon/wallet.png";
import bgNew2 from "../../Image/bgNew2.png";

const Sidebar = () => {
  const { auth, logOut, setShowSidebar, showSidebar } = useContext(Auth);

  const location = useLocation();

  const handleLogout = () => {
    logOut();
  };

  const checkCurrentRoute = (routeName) => {
    if (location?.pathname === routeName) return "text-[#178ACB]";
    else return "text-[#878787]";
  };

  return (
    <>
      <div
        className={`  overflow-y-scroll overflow-x-hidden sbar font-museob top-0 ease-in-out duration-500 fixed z-40 flex flex-col w-64 h-screen py-8 bg-white border-r dark:bg-gray-900 dark:border-gray-700 ${
          showSidebar ? "translate-x-0 " : "-translate-x-[100%]"
        } `}
      >
        {/* <h2 className="text-3xl font-museobb text-center text-gray-800 dark:text-white">Brand</h2> */}

        <div
          className="flex justify-center items-center"
          onClick={() => {
            setShowSidebar(!showSidebar);
          }}
        >
          <Link to="/">
            <img className="w-[200px]" src={logo} alt="" />
          </Link>
        </div>

        <div className="flex flex-col items-center mt-6 -mx-2">
          <Link to="/profile">
            <img
              onClick={() => {
                setShowSidebar(!showSidebar);
              }}
              className=" object-cover object-top w-24 h-24 mx-2 rounded-full"
              src={auth?.user?.avatar ? auth?.user?.avatar : profile}
              alt="avatar"
            />
          </Link>
          <p className="mx-2 mt-1 text-sm font-museob text-gray-600 dark:text-gray-400 hover:underline">
            Hello,
          </p>
          <h4 className="mx-2 mt-2 font-museobb text-gray-800 dark:text-gray-200 hover:underline">
            {auth?.userRole === "BRAND"
              ? auth?.user?.owner_name
              : auth?.user?.name}
          </h4>
        </div>

        <div className="flex  w-full justify-center my-4 min-h-fit">
          <div className="bg-[#BBD5E8] rounded-full flex min-w-[216px] min-h-[56px] items-center ">
            <div className=" bg-[#9EC8E4] border-[3px] border-white min-w-[64px] min-h-[64px] flex items-center justify-center rounded-full">
              <img src={wallet} className=" w-6 h-6" alt="" />
            </div>

            <div className="mx-2 break-all">
              <span className="text-[11px] font-museob ">Dreams Wallet</span>
              <p className="text-black font-museobb ">
                RM {currencyFormatter.format(auth?.user?.wallet_balance)}74
              </p>
            </div>
          </div>
        </div>

        <div
          className="flex flex-col justify-between flex-1 "
          onClick={() => {
            setShowSidebar(!showSidebar);
          }}
        >
          {auth?.userRole === "BRAND" && (
            <nav className="px-4 ">
              <Link
                to="/my-campaigns"
                className={`flex items-center pt-0  ${checkCurrentRoute(
                  "/my-campaigns"
                )}  font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={camIcon} alt="cam-icon" className="w-7 h-7"></img>
                <p className="mx-4">My Campaign dfs</p>
              </Link>

              <Link
                to="/tasks"
                className={`flex items-center pt-5   ${checkCurrentRoute(
                  "/tasks"
                )}  font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={camIcon} alt="cam-icon" className="w-7 h-7"></img>
                <p className="mx-4">My Tasks</p>
              </Link>

              <div className="flex items-center pt-5">
                <img src={logout} alt="logout-icon" className="w-6 h-6"></img>
                <Link
                  to=""
                  onClick={handleLogout}
                  className={`mx-4 font-museobb ${checkCurrentRoute(
                    "/logOut"
                  )} focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
                >
                  Logout
                </Link>
              </div>
            </nav>
          )}

          {auth.userRole === "INFLUENCER" && (
            <nav className="px-4 ">
              <Link
                to="/campaigns"
                className={`flex items-center pt-0 ${checkCurrentRoute(
                  "/campaigns"
                )} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={camIcon} alt="cam-icon" className="w-7 h-7"></img>
                <p className="mx-4">Campaigns</p>
              </Link>

              <Link
                to="/my-posts"
                className={`flex items-center pt-5  ${checkCurrentRoute(
                  "/my-posts"
                )} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={myPosts} alt="post-icon" className="w-6 h-6"></img>
                <p className="mx-4">My Posts</p>
              </Link>

              <Link
                to="/my-payouts"
                className={`flex items-center pt-5 ${checkCurrentRoute(
                  "/my-payouts"
                )} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={payouts} alt="payouts-icon" className="w-7 h-7"></img>
                <p className="mx-4">Payouts</p>
              </Link>

              <Link
                to="/CamRequest"
                className={`flex items-center pt-5 ${checkCurrentRoute(
                  "/cam_li"
                )} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={report} alt="report" className="w-7 h-7"></img>
                <p className="mx-4">Reports</p>
              </Link>

              <div
                onClick={handleLogout}
                className={`flex items-center pt-5  ${checkCurrentRoute(
                  "/logOut"
                )} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}
              >
                <img src={logout} alt="logout-icon" className="w-6 h-6"></img>
                <p className="mx-4">Logout</p>
              </div>
            </nav>
          )}

          {auth.userRole === null && <nav className="px-4 "></nav>}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
